<template>
  <header id="header-m">
    <div class="menu">
      <router-link tag="div" class="item" to="/">首页</router-link>
      <router-link tag="div" class="item" to="/productsType">产品中心</router-link>
      <router-link tag="div" class="item" to="/about">博洋生活</router-link>
      <router-link tag="div" class="item" to="/news">企业动态</router-link>
      <router-link tag="div" class="item" to="/agent">授权代理</router-link>
      <router-link tag="div" class="item" to="/contact">联系我们</router-link>
    </div>
  </header>
</template>

<script>
import Scrollbar from 'smooth-scrollbar';
export default {
  data(){
    return{
      scrollbar: '',
      scrollTop: 0,
      input:'',
      inputShow:false
    }
  },
  watch: {
    $route: 'getScrollbar'
  },
  mounted() {
    this.getScrollbar()
  },
  methods: {
    getScrollbar(){
      
    },
    handleCommand(command) {
      this.$router.push(command)
    }
  }
}
</script>

<style scoped>
header{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 80vw;
  background-color: #f3f3f3;
  z-index: 100;
  transform: translateX(-30%);
}
header.show{
  transform: translateX(0);
  transition: .4s;
}
header .menu .item{
  padding: 12px 10px 12px 20px;
  font-size: 14px;
  line-height: 24px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
</style>
